/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import { withRouter } from 'react-router-dom';
import { Button, Grid, Typography } from '@mui/material';
import moment from 'moment';
import * as selectorsVeiculos from '../../../store/veiculo/reducer';
import * as actionsVeiculos from '../../../store/veiculo/actions';
import * as selectorsAuth from '../../../store/auth/reducer';
import {
  InputV2,
  DefaultSelectV2,
  DialogDefaultV2,
  NumberInputV2,
  TrueFalseSelectV2,
  ArquivoContainerV2,
  DatePickerV2,
  UsuarioSelectV2,
  DateTimePickerV2,
  YearMonthPickerV2,
} from '../../../components/v2';
import ManutencaoVeicularContainer from '../Notas/ManutencaoVeicularContainer';
import PecasManutencaoContainer from '../Notas/PecasManutencaoContainer';
import NotaFormulario from '../Notas/Formulario';
import {
  getAnoExercicio,
  getValorAnualIpva,
  getValorMensalIpva,
  hasIpvaDuplicado,
  isHistoricoReadOnly,
  isIpva,
  isLimpezaVeicular,
  isTermoDeslocamento,
  parseAnoIpva,
  toAnoPickerValue,
} from './helpers';

const schema = {
  tipoHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  dataHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const schemaRepasse = {
  tipoHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  dataHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  tipoRepasse: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  garagem: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  usuario: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const schemaManutencao = {
  tipoHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  dataHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  valorManutencao: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  observacao: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const schemaLimpeza = {
  tipoHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  dataHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  valorManutencao: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  observacao: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const schemaPecas = {
  tipoHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  dataHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  valorPecas: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  observacao: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const schemaVendaTroca = {
  tipoHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  dataHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  valorRecebido: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  observacao: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const schemaMulta = {
  tipoHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  dataHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  multaPrazo: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const schemaIpva = {
  tipoHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  ano: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  valorIpva: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const schemaTermo = {
  tipoHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  dataHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  usuario: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  autorizadoPor: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const getSchema = (tipoHistorico) => {
  switch (tipoHistorico) {
    case 'MANUTENCAO':
      return schemaManutencao;
    case 'LIMPEZA':
      return schemaLimpeza;
    case 'PECAS':
      return schemaPecas;
    case 'AUTUACAO':
    case 'MULTA':
      return schemaMulta;
    case 'REPASSE_COLABORADOR':
      return schemaRepasse;
    case 'VENDA_TROCA':
      return schemaVendaTroca;
    case 'IPVA':
      return schemaIpva;
    case 'TERMO_DESLOCAMENTO':
      return schemaTermo;
    default:
      return schema;
  }
};

const repasseFields = (values, handleChange, setValues, errors) => (
  <>
    <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 0 }}>
      <UsuarioSelectV2
        label="Colaborador"
        onSelect={(usuario) => setValues({
          ...values,
          usuario,
        })}
        ativo
        value={values.usuario}
        error={!!(errors && errors.usuario)}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 2 }} sx={{ pb: 0 }}>
      <NumberInputV2
        prefix=""
        label="Km Atual"
        name="kmAtual"
        onChange={(valor) => setValues({
          ...values,
          kmAtual: valor,
        })}
        value={values.kmAtual}
        decimalScale={0}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
      <InputV2
        label="Região"
        name="regiao"
        onChange={handleChange}
        value={values.regiao || ''}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 0 }}>
      <DefaultSelectV2
        error={!!(errors && errors.tipoRepasse)}
        isRequired
        label="Tipo"
        name="tipoRepasse"
        showEmpty
        options={[
          { id: 'ENTREGA', nome: 'Entrega' },
          { id: 'DEVOLUCAO', nome: 'Devolução' },
        ]}
        onSelect={handleChange}
        value={values.tipoRepasse}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 0 }}>
      <TrueFalseSelectV2
        error={!!(errors && errors.garagem)}
        isRequired
        label="Está na Garagem"
        name="garagem"
        onChange={handleChange}
        value={values.garagem}
      />
    </Grid>
  </>
);

const termoFields = (values, setValues, errors, readOnly) => (
  <>
    <Grid size={{ xs: 12 }} sx={{ pb: 0 }}>
      <Typography variant="caption" color="text.secondary">
        Autorização de uso de veículo da empresa para fins particulares.
      </Typography>
    </Grid>
    <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 0 }}>
      <UsuarioSelectV2
        label="Colaborador"
        isRequired
        onSelect={(usuario) => setValues({
          ...values,
          usuario,
        })}
        ativo
        value={values.usuario}
        error={!!(errors && errors.usuario)}
        disabled={readOnly}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 0 }}>
      <UsuarioSelectV2
        label="Autorizado por"
        isRequired
        onSelect={(autorizadoPor) => setValues({
          ...values,
          autorizadoPor,
        })}
        ativo
        value={values.autorizadoPor}
        error={!!(errors && errors.autorizadoPor)}
        disabled={readOnly}
      />
    </Grid>
  </>
);

const limpezaFields = (values, handleChange, setValues, errors, readOnly) => (
  <>
    <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
      <NumberInputV2
        prefix="R$"
        label="Valor da Limpeza"
        name="valorManutencao"
        onChange={(valor) => setValues({
          ...values,
          valorManutencao: valor,
        })}
        value={values.valorManutencao}
        decimalScale={2}
        error={!!(errors && errors.valorManutencao)}
        disabled={readOnly}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
      <TrueFalseSelectV2
        label="Foi Pago"
        name="pago"
        onChange={handleChange}
        value={values.pago}
        disabled={readOnly}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
      <TrueFalseSelectV2
        label="Emitiu Nota Fiscal"
        onChange={handleChange}
        name="notaFiscal"
        value={values.notaFiscal}
        disabled={readOnly}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 0 }}>
      <InputV2
        label="Profissional Responsável"
        name="profissionalResponsavel"
        onChange={handleChange}
        value={values.profissionalResponsavel || ''}
        disabled={readOnly}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 0 }}>
      <InputV2
        label="Empresa"
        name="empresa"
        onChange={handleChange}
        value={values.empresa || ''}
        disabled={readOnly}
      />
    </Grid>
  </>
);

const manutencaoFields = (
  values,
  handleChange,
  setValues,
  errors,
  setNotaView,
  manutencoes,
  setManutencoes,
  readOnly,
) => (
  <>
    <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
      <NumberInputV2
        prefix="R$"
        label="Valor da Manutenção"
        name="valorManutencao"
        onChange={(valor) => setValues({
          ...values,
          valorManutencao: valor,
        })}
        value={values.valorManutencao}
        decimalScale={2}
        error={!!(errors && errors.valorManutencao)}
        disabled={readOnly}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 2 }} sx={{ pb: 0 }}>
      <NumberInputV2
        prefix=""
        label="Km Atual"
        name="kmAtual"
        onChange={(valor) => setValues({
          ...values,
          kmAtual: valor,
        })}
        value={values.kmAtual}
        decimalScale={0}
        disabled={readOnly}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
      <TrueFalseSelectV2
        label="Foi Pago"
        name="pago"
        onChange={handleChange}
        value={values.pago}
        disabled={readOnly}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
      <TrueFalseSelectV2
        label="Emitiu Nota Fiscal"
        onChange={handleChange}
        name="notaFiscal"
        value={values.notaFiscal}
        disabled={readOnly}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 0 }}>
      <InputV2
        label="Profissional Responsável"
        name="profissionalResponsavel"
        onChange={handleChange}
        value={values.profissionalResponsavel || ''}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 0 }}>
      <InputV2
        label="Empresa"
        name="empresa"
        onChange={handleChange}
        value={values.empresa || ''}
      />
    </Grid>
    {values.notaId && (
      <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
        <Button
          variant="outlined"
          size="medium"
          onClick={() => setNotaView({ id: values.notaId, open: true })}
        >
          Nota Vinculada
        </Button>
      </Grid>
    )}
    <Grid size={{ xs: 12 }} sx={{ pb: 0 }}>
      <ManutencaoVeicularContainer
        manutencoes={manutencoes}
        onSave={setManutencoes}
        readOnly={readOnly}
      />
    </Grid>
  </>
);

const pecasFields = (
  values,
  handleChange,
  setValues,
  errors,
  setNotaView,
  compraNotas,
  setCompraNotas,
  readOnly,
) => (
  <>
    <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
      <NumberInputV2
        prefix="R$"
        label="Valor da Peças"
        name="valorPecas"
        onChange={(valor) => setValues({
          ...values,
          valorPecas: valor,
        })}
        value={values.valorPecas}
        decimalScale={2}
        error={!!(errors && errors.valorPecas)}
        disabled={readOnly}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 2 }} sx={{ pb: 0 }}>
      <TrueFalseSelectV2
        label="Foi Pago"
        name="pago"
        onChange={handleChange}
        value={values.pago}
        disabled={readOnly}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 2 }} sx={{ pb: 0 }}>
      <TrueFalseSelectV2
        label="Emitiu Nota Fiscal"
        onChange={handleChange}
        name="notaFiscal"
        value={values.notaFiscal}
        disabled={readOnly}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
      <InputV2
        label="Empresa"
        name="empresa"
        onChange={handleChange}
        value={values.empresa || ''}
      />
    </Grid>
    {values.notaId && (
      <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
        <Button
          variant="outlined"
          size="medium"
          onClick={() => setNotaView({ id: values.notaId, open: true })}
        >
          Nota Vinculada
        </Button>
      </Grid>
    )}
    <Grid size={{ xs: 12 }} sx={{ pb: 0 }}>
      <PecasManutencaoContainer
        pecas={compraNotas}
        onSave={setCompraNotas}
        readOnly={readOnly}
      />
    </Grid>
  </>
);

const multaFields = (values, handleChange, setValues, errors) => (
  <>
    <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 0 }}>
      <DatePickerV2
        label="Prazo"
        isRequired
        error={!!(errors && errors.multaPrazo)}
        onChange={(data) => setValues({
          ...values,
          multaPrazo: data,
        })}
        value={values.multaPrazo}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 0 }}>
      <NumberInputV2
        prefix="R$"
        label="Valor"
        name="multaValor"
        onChange={(valor) => setValues({
          ...values,
          multaValor: valor,
        })}
        value={values.multaValor}
        decimalScale={2}
        error={!!(errors && errors.multaValor)}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 0 }}>
      <UsuarioSelectV2
        label="Condutor"
        onSelect={(usuario) => setValues({
          ...values,
          multaCondutor: usuario,
        })}
        ativo
        value={values.multaCondutor}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
      <TrueFalseSelectV2
        label="Enviada ao Condutor"
        name="multaEnviadaCondutor"
        onChange={handleChange}
        value={values.multaEnviadaCondutor}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
      <TrueFalseSelectV2
        label="Enviada ao DNIT"
        name="multaEnviadaDnit"
        onChange={handleChange}
        value={values.multaEnviadaDnit}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 0 }}>
      <InputV2
        label="Cód de Postagem ECT"
        name="multaCodPostagemEct"
        onChange={handleChange}
        value={values.multaCodPostagemEct || ''}
      />
    </Grid>
    {values.tipoHistorico === 'MULTA' && (
      <>
        <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
          <TrueFalseSelectV2
            label="Multa Paga"
            name="multaPaga"
            onChange={handleChange}
            value={values.multaPaga}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
          <DatePickerV2
            label="Data Pagamento"
            error={!!(errors && errors.multaDtPagamento)}
            onChange={(data) => setValues({
              ...values,
              multaDtPagamento: data,
            })}
            value={values.multaDtPagamento}
          />
        </Grid>
      </>
    )}
  </>
);

const vendaTrocaFields = (values, setValues, errors) => (
  <Grid size={{ xs: 12 }} sx={{ pb: 0 }}>
    <NumberInputV2
      prefix="R$"
      label="Valor Recebido"
      name="valorRecebido"
      onChange={(valor) => setValues({
        ...values,
        valorRecebido: valor,
      })}
      value={values.valorRecebido}
      decimalScale={2}
      error={!!(errors && errors.valorRecebido)}
    />
  </Grid>
);

const ipvaFields = (values, setValues, errors, readOnly) => (
  <>
    <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
      <YearMonthPickerV2
        label="Ano de exercício"
        isRequired
        onlyYear
        error={!!(errors && errors.ano)}
        disabled={readOnly}
        value={toAnoPickerValue(values.ano)}
        onChange={(val) => setValues({
          ...values,
          ano: parseAnoIpva(val) ?? val,
        })}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
      <NumberInputV2
        prefix="R$"
        label="Valor"
        name="valorIpva"
        isRequired
        decimalScale={2}
        disabled={readOnly}
        error={!!(errors && errors.valorIpva)}
        value={values.valorIpva}
        onChange={(valor) => setValues({
          ...values,
          valorIpva: valor,
        })}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
      <NumberInputV2
        prefix="R$"
        label="Valor mensal"
        name="valorMensal"
        decimalScale={2}
        fixedDecimalScale
        disabled
        value={getValorMensalIpva(values.valorIpva)}
        onChange={() => {}}
      />
    </Grid>
  </>
);

const HistoricoVeiculoModal = ({
  upsertHistorico,
  selectedHistoricoVeiculo,
  open,
  id,
  onClose,
  findHistoricoById,
  authData,
  idVeiculo,
  afterSave,
  historicoRows,
}) => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [notaView, setNotaView] = useState({ id: null, open: false });
  const [manutencoes, setManutencoes] = useState([]);
  const [compraNotas, setCompraNotas] = useState([]);
  const [readOnly, setReadOnly] = useState(false);

  useEffect(() => {
    if (open) {
      setValues({
        criadoPor: authData.id,
        criadoPorName: authData.nome,
        dataInclusao: moment().format('DD/MM/YYYY HH:mm:ss'),
      });
    } else {
      setValues({});
      setManutencoes([]);
      setCompraNotas([]);
      setReadOnly(false);
    }
  }, [authData, open]);

  useEffect(() => {
    if (id) findHistoricoById(id);
  }, [id, findHistoricoById]);

  useEffect(() => {
    if (id && selectedHistoricoVeiculo && id === selectedHistoricoVeiculo.id) {
      const loaded = selectedHistoricoVeiculo;
      setValues(isIpva(loaded.tipoHistorico)
        ? {
          ...loaded,
          ano: getAnoExercicio(loaded),
          valorIpva: getValorAnualIpva(loaded),
        }
        : loaded);
      setManutencoes(selectedHistoricoVeiculo.manutencoes || []);
      setCompraNotas(selectedHistoricoVeiculo.compraNotas || []);
      setReadOnly(isHistoricoReadOnly(selectedHistoricoVeiculo));
    }
  }, [id, selectedHistoricoVeiculo]);

  const onSave = () => {
    const ano = isIpva(values.tipoHistorico) ? parseAnoIpva(values.ano) : values.ano;
    const valuesToValidate = isIpva(values.tipoHistorico)
      ? { ...values, ano }
      : values;
    const erros = validate(valuesToValidate, getSchema(values.tipoHistorico));
    if (!erros && isIpva(values.tipoHistorico) && hasIpvaDuplicado(historicoRows, ano, id)) {
      setErrors({ ano: ['já existe IPVA para este ano'] });
      return;
    }
    if (!erros && isTermoDeslocamento(values.tipoHistorico)) {
      const arquivos = values.arquivos || [];
      if (arquivos.length === 0) {
        setErrors({ arquivos: ['é obrigatório anexar o termo'] });
        return;
      }
    }
    setErrors(erros);
    if (!erros) {
      const rest = { ...valuesToValidate };
      if (isIpva(values.tipoHistorico)) {
        delete rest.ano;
        upsertHistorico({
          ...rest,
          ipvaAno: ano,
          valorIpva: values.valorIpva,
          valorMensal: getValorMensalIpva(values.valorIpva),
          dataHistorico: rest.dataHistorico
            || moment(`${ano}-01-01`).startOf('year').valueOf(),
          veiculo: idVeiculo,
          manutencoes,
        }, saveCallback);
        return;
      }
      upsertHistorico({
        ...rest,
        veiculo: idVeiculo,
        manutencoes,
      }, saveCallback);
    }
  };

  const saveCallback = (success, data) => {
    if (success) {
      setValues({});
      onCloseLocal(true);
      afterSave(data);
    }
  };

  const onCloseLocal = (isSave) => {
    setErrors({});
    onClose(isSave);
    setNotaView({ id: null, open: false });
  };

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeTipo = (event) => {
    const nextTipo = event.target.value;
    if (isLimpezaVeicular(values.tipoHistorico) && nextTipo === 'LIMPEZA') {
      return;
    }
    setValues(isIpva(nextTipo)
      ? { tipoHistorico: nextTipo, ano: moment().year() }
      : { tipoHistorico: nextTipo });
    setErrors({});
  };

  const titleData = () => {
    switch (values.tipoHistorico) {
      case 'MANUTENCAO':
        return 'Data da Manutenção';
      case 'LIMPEZA':
        return 'Data da Limpeza';
      case 'PECAS':
        return 'Data da Compra';
      case 'MULTA':
        return 'Data e Hora da Multa';
      case 'AUTUACAO':
        return 'Data e Hora da Autuação';
      case 'REPASSE_COLABORADOR':
        return 'Data da Entrega';
      case 'VENDA_TROCA':
        return 'Data da Transferência';
      case 'IPVA':
        return 'Ano de exercício';
      case 'TERMO_DESLOCAMENTO':
        return 'Data do termo';
      default:
        return 'Data';
    }
  };

  const titleObservacao = () => {
    switch (values.tipoHistorico) {
      case 'VENDA_TROCA':
        return 'Negociação (Observação)';
      default:
        return 'Observação';
    }
  };

  return (
    <>
      <DialogDefaultV2
        open={open}
        handlerCancel={() => onCloseLocal(false)}
        handlerConfirm={onSave}
        title="Histórico do Veículo"
        confirmMessage="Salvar"
        maxWidth="md"
        fullWidth
        readOnly={readOnly}
      >
        <Grid container spacing={1} sx={{ mt: 0 }}>
          <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
            <DefaultSelectV2
              error={!!(errors && errors.tipoHistorico)}
              isRequired
              label="Tipo do Histórico"
              name="tipoHistorico"
              showEmpty
              options={[
                { id: 'AUTUACAO', nome: 'Autuação' },
                { id: 'IPVA', nome: 'IPVA' },
                { id: 'LIMPEZA', nome: 'Limpeza Veicular' },
                { id: 'MANUTENCAO', nome: 'Manutenção' },
                { id: 'MULTA', nome: 'Multa' },
                { id: 'PECAS', nome: 'Peças' },
                { id: 'REPASSE_COLABORADOR', nome: 'Repasse' },
                { id: 'TERMO_DESLOCAMENTO', nome: 'Termo de uso particular' },
                { id: 'VENDA_TROCA', nome: 'Venda/Troca' },
              ]}
              onSelect={handleChangeTipo}
              value={isLimpezaVeicular(values.tipoHistorico)
                ? 'LIMPEZA'
                : values.tipoHistorico}
              disabled={readOnly}
            />
          </Grid>
          {values.tipoHistorico
            && values.tipoHistorico !== 'MULTA'
            && values.tipoHistorico !== 'AUTUACAO'
            && !isIpva(values.tipoHistorico) && (
            <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
              <DatePickerV2
                label={titleData()}
                error={!!(errors && errors.dataHistorico)}
                onChange={(data) => setValues({
                  ...values,
                  dataHistorico: data,
                })}
                value={values.dataHistorico}
                disabled={readOnly}
              />
            </Grid>
          )}
          {isIpva(values.tipoHistorico)
            && ipvaFields(values, setValues, errors, readOnly)}
          {values.tipoHistorico
            && (values.tipoHistorico === 'MULTA' || values.tipoHistorico === 'AUTUACAO') && (
            <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
              <DateTimePickerV2
                label={titleData()}
                error={!!(errors && errors.dataHistorico)}
                onChange={(data) => setValues({
                  ...values,
                  dataHistorico: data,
                })}
                value={values.dataHistorico}
                disabled={readOnly}
              />
            </Grid>
          )}
          <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
            <InputV2 label="Criado Por" disabled value={values.criadoPorName || ''} />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
            <InputV2 label="Data Inclusão" disabled value={values.dataInclusao || ''} />
          </Grid>
          {values.tipoHistorico === 'MANUTENCAO'
            && manutencaoFields(
              values,
              handleChange,
              setValues,
              errors,
              setNotaView,
              manutencoes,
              setManutencoes,
              readOnly,
            )}
          {isLimpezaVeicular(values.tipoHistorico)
            && limpezaFields(values, handleChange, setValues, errors, readOnly)}
          {values.tipoHistorico === 'PECAS'
            && pecasFields(
              values,
              handleChange,
              setValues,
              errors,
              setNotaView,
              compraNotas,
              setCompraNotas,
              readOnly,
            )}
          {(values.tipoHistorico === 'MULTA' || values.tipoHistorico === 'AUTUACAO')
            && multaFields(values, handleChange, setValues, errors)}
          {values.tipoHistorico === 'REPASSE_COLABORADOR'
            && repasseFields(values, handleChange, setValues, errors)}
          {values.tipoHistorico === 'VENDA_TROCA'
            && vendaTrocaFields(values, setValues, errors)}
          {isTermoDeslocamento(values.tipoHistorico)
            && termoFields(values, setValues, errors, readOnly)}
          {values.tipoHistorico && (
            <Grid size={{ xs: 12 }} sx={{ pb: 0 }}>
              <InputV2
                label={titleObservacao()}
                name="observacao"
                onChange={handleChange}
                value={values.observacao || ''}
                rows={3}
                multiline
                error={
                  !!(errors && errors.observacao
                    && (values.tipoHistorico === 'MANUTENCAO'
                      || isLimpezaVeicular(values.tipoHistorico)
                      || values.tipoHistorico === 'VENDA_TROCA'))
                }
                disabled={readOnly}
              />
            </Grid>
          )}
          <Grid size={{ xs: 12 }} sx={{ pb: 0 }}>
            {errors && errors.arquivos && (
              <Typography variant="caption" color="error" sx={{ display: 'block', mb: 0.5 }}>
                {errors.arquivos[0]}
              </Typography>
            )}
            <ArquivoContainerV2
              arquivos={values.arquivos || []}
              onSave={(arquivos) => setValues({ ...values, arquivos })}
              disabled={readOnly}
              headerTitle={isTermoDeslocamento(values.tipoHistorico)
                ? 'Termo assinado'
                : 'Arquivos'}
              addTitle={isTermoDeslocamento(values.tipoHistorico)
                ? 'Anexar termo'
                : 'Novo'}
            />
          </Grid>
        </Grid>
      </DialogDefaultV2>
      <NotaFormulario
        id={notaView.id}
        open={notaView.open}
        onClose={() => setNotaView({ id: null, open: false })}
        isAdmin={false}
      />
    </>
  );
};

HistoricoVeiculoModal.propTypes = {
  upsertHistorico: PropTypes.func.isRequired,
  selectedHistoricoVeiculo: PropTypes.object,
  open: PropTypes.bool.isRequired,
  id: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  findHistoricoById: PropTypes.func.isRequired,
  authData: PropTypes.object.isRequired,
  idVeiculo: PropTypes.string,
  afterSave: PropTypes.func.isRequired,
  historicoRows: PropTypes.array,
};

HistoricoVeiculoModal.defaultProps = {
  historicoRows: [],
};

const mapStateToProps = (state) => ({
  selectedHistoricoVeiculo: selectorsVeiculos.getSelectedHistoricoVeiculo(state),
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...actionsVeiculos,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(HistoricoVeiculoModal));
